import type { ReactElement } from 'react'

import { LinkButton } from './LinkButton'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { AHeading } from '@/components/layouts/Ir/Heading'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'
import { ZenkakuSpace } from '@/components/pages/Legal/TextStyle'

export const MailPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="IR Mail"
        subTitleText="IRメール配信"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <AHeading>IRメール配信のお申し込み</AHeading>
      <Paragraph>
        IRメール配信にお申込みいただいた方へ、適時開示情報・法定開示情報などをお届けいたします。
      </Paragraph>
      <Paragraph>
        ※株式会社マジカルポケットが提供するメール配信サービスを利用しています。
      </Paragraph>
      <Paragraph>
        <ZenkakuSpace />
        これより先は同社の「IRメール配信サービス」のサイトとなります。
      </Paragraph>
      <Spacer h={{ sp: 30, pc: 50 }} />
      <LinkButton url="https://www.magicalir.net/141A/irmail/index.php">
        IRメール配信のお申し込み
      </LinkButton>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <AHeading>IRメール配信の停止</AHeading>
      <Paragraph>
        IRメール配信の停止をご希望の方は、下記バナーよりお申し込み下さい。
      </Paragraph>
      <Paragraph>
        お申し込み後に手続きのご案内メールをお送りしますので、そちらに従いお手続きをお願いいたします。
      </Paragraph>
      <Paragraph>
        ※IRメール配信にお申込みいただいたメールアドレスの変更は、いったん配信停止したうえで、再度新しいメールアドレスを登録いただきますようお願いいたします。
      </Paragraph>
      <Spacer h={{ sp: 30, pc: 50 }} />
      <LinkButton url="https://www.magicalir.net/141A/irmail/stopmail.php">
        IRメール配信の停止
      </LinkButton>
    </Layout>
  )
}

MailPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主、投資家向け情報', path: '/ir' },
    { name: 'IRメール配信', path: '' },
  ]

  return (
    <>
      <Head
        title="IRメール配信"
        description="トライアルホールディングスのIRメール配信のお申し込み方法、停止方法について掲載しています。"
        ogp={{ url: 'ir/mail' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
